import { Colors, Hover } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef, HTMLProps, useRef } from "react";
import { APP_VERSION } from "../../helpers/utils";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";

export interface VersionsProps extends HTMLProps<HTMLDivElement> {
  className?: string;
  style?: React.CSSProperties;
}

export interface VersionsRef {}

const Versions = React.forwardRef(({ className, style, ...divProps }: VersionsProps, forwardRef: ForwardedRef<VersionsRef | undefined>) => {
  const backendVersionRef = useRef<HTMLDivElement>(null);
  const compatibilityInfos = useAppStoreSelector(state => state.compatibilityInfos);
  const renderFullBackendVersion = () => (
    <>
      <div style={Object.assign({}, !compatibilityInfos?.apiRest?.isSupported ? { color: "red" } : {})}>
        Backend - API REST Version : {compatibilityInfos?.apiRest?.apiVersion}
      </div>
      <div style={Object.assign({}, !compatibilityInfos?.websocketServer?.isSupported ? { color: "red" } : {})}>
        Backend - Websocket Server Version : {compatibilityInfos?.websocketServer?.apiVersion}
      </div>
    </>
  );
  return (
    <div {...divProps}>
      <div>Application Version : {APP_VERSION}</div>
      {compatibilityInfos?.apiRest?.apiVersion === compatibilityInfos?.websocketServer?.apiVersion ? (
        <div
          ref={backendVersionRef}
          style={Object.assign({}, !compatibilityInfos?.apiRest?.isSupported || !compatibilityInfos?.websocketServer?.isSupported ? { color: "red" } : {})}
        >
          Backend Version : {compatibilityInfos?.apiRest?.apiVersion}
          <Hover targetRef={backendVersionRef}>
            <div style={{ backgroundColor: Colors.getBluePrussian(0.8), padding: "10px", borderRadius: "10px", color: "white" }}>
              {renderFullBackendVersion()}
            </div>
          </Hover>
        </div>
      ) : (
        renderFullBackendVersion()
      )}
    </div>
  );
});

export default Versions;
